export const RenewableKey = {
  TYPE: 'powerType',
  CAPACITY_UNIT: 'capacityUnit',
  TOTAL_CAPACITY: 'totalCapacity',
  PROVIDER_NAME: 'providerName',
  SELF_GENERATED_TF: 'selfgenerated',
  PURCHASED_TF: 'purchased',
  PURCHASED_COST_TF: 'purchasedcost',
  STATUS: 'status',
  COMMENT: 'comment'
};
export const RenewableLabel = {
  TYPE: 'Type',
  TOTAL_CAPACITY: 'Total Capacity',
  PROVIDER_NAME: 'Provider Name',
  SELF_GENERATED_TF: 'Self- Generated',
  PURCHASED_TF: 'Purchased',
  PURCHASED_COST_TF: 'Purchased Cost',
  FULL_INFO: 'Full Info',
  STATUS: 'Status',
  COMMENT: 'Comment'
};
